// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQd-s","select":"styles_select__1PvwT"};